import { cookieStorage } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { CART_ITEMS_DATA_QUERY_KEY } from './types';

const useCartItems = () => {
  const { data: cartItems } = useStrictQuery([CART_ITEMS_DATA_QUERY_KEY], async () => {
    const { data } = await cookieStorage.get('cartItems');

    return Number(data);
  });

  return { cartItems };
};

export default useCartItems;
